export default {"src":"/_next/static/image/public/images/flags/flag_500.60dc7fd38dedd90b0f129582420265cf.svg","height":16,"width":24};